module.exports = __webpack_public_path__ + "img/map.7bb0fa9f.png";